import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import SettingsIcon from "@mui/icons-material/Settings";

import GPAP_Button from "../../../../gpap-lib/Button_Collection";

import auth from "../../../Auth";

// this page is only rendered if logged in as admin
class AdminView extends Component {
  render() {
    return (
      <>
        {auth.getUserGroups().includes("admin") ? (
          <div className="home">
            <Typography variant={"h4"} align={"center"}>
              {" "}
              Hello admin please act responsible{" "}
            </Typography>
            <hr className="divider" />
            <div className="ctas">
              <div className="container">
                {/* TODO create this buttons w/ for loop */}
                <Grid
                  container
                  direction={"column"}
                  justify={"center"}
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <GPAP_Button
                      // redirect to projects view but with admin flag set to true
                      style={{ width: "300px" }}
                      href="#/admin/projects"
                      startIcon={<SettingsIcon />}
                      data-cy={"show-admin-projects-view"}
                    >
                      Projects
                    </GPAP_Button>
                  </Grid>
                  <Grid item xs={12}>
                    {" "}
                    <GPAP_Button
                      // redirect to datasets view but with admin flag set to true
                      style={{ width: "300px" }}
                      href="#/admin/datasets"
                      startIcon={<SettingsIcon />}
                      data-cy={"show-admin-datasets-view"}
                    >
                      Datasets
                    </GPAP_Button>
                  </Grid>
                  <Grid item xs={12}>
                    <GPAP_Button
                      // redirect to files view but with admin flag set to true
                      // admin version not yet implemented
                      id={"files"}
                      style={{ width: "300px" }}
                      href="#/admin/files"
                      startIcon={<SettingsIcon />}
                      data-cy={"show-admin-files-view"}
                    >
                      Files
                    </GPAP_Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default AdminView;
